function navigation() {

  // Scroll Button
  if ( !! $('#tickets-app').length || !! $('.snlinks').length ) {

      $('.scrollbtn>a').each(function (index) {

          var el = $(this);
          var str = el.attr('href');

          var url = window.location.pathname;
          //log(str, url);

          // if the URL is the same page, then remove it just down to the hash
          if (str.indexOf(url) != -1) {

              strnew = str.substring(str.indexOf("#"));
              //log('yes: before:' + str +' | after: '+strnew);
              el.attr('href', strnew);
              el.anchorAnimate();

          }

          el.parent().removeClass('current-menu-item');

      })

  }


  if( !! $(".side-nav li.menu-item-has-children").length) {

      $('.side-nav li ul li.current-menu-item').parent().parent().addClass('current-menu-item');
      $('.side-nav li ul li.current-menu-item').addClass('active');
      $('.side-nav > div').addClass('hidearrows');

  }

  // If hash exists, click the hash's relevant link
  if(window.location.hash) {
      window.scrollTo(0, 0);
      setTimeout(function() {
          window.scrollTo(0, 0);
      }, 1);

      setTimeout(function() {
          var hash = window.location.hash;
          try {
              var $hashElement = $(hash);
              if ($hashElement.length) {
                  $(`a[href="${hash}"]`).trigger('click');
                  log("Scroll hash: " + hash);

                  var destination = $hashElement.offset().top;
                  $("html:not(:animated),body:not(:animated)").animate({
                      scrollTop: destination
                  }, 1200, 'easeInOutExpo');
              }
          } catch (error) {
              log("Invalid hash: " + hash);
          }
      }, 1200);
  }

  // Content Load //TODO: What is the purpose of all this?
  if ( /*!! $('body.page-template-page-home-migrate-php').length ||*/  !! $('body.page-template-page-livestream-php').length ) {
      var delaytime = $('body.admin-bar').length ? 100 : 1600;

      setTimeout(function() {
          $('#main').addClass('opacity100f');
          $('#background').addClass('opacity100f');
          $('.background-overlay>.loader').fadeOut(600);
          if ( !!$(".ticket-meter").length  ) {
              GAmeterDance();
              if($(".vip-meter").length ) {
                  setTimeout(function(){
                      VIPmeterDance();
                  }, vipdelay)
              }
          }
          if ( !!$(".dynamic-meter").length ) {
              dynamicMeterDance();
          }
      }, delaytime);

  } else {

      setTimeout(function() {
          $('#main').addClass('opacity100f');
          $('#background').addClass('opacity100f');
      },250);

      if ( !!$(".ticket-meter").length  ) {
          GAmeterDance();
          if($(".vip-meter").length ) {
              setTimeout(function(){
                  VIPmeterDance();
              }, vipdelay)
          }
      }
      if ( !!$(".dynamic-meter").length ) {
          dynamicMeterDance();
      }
  }

}


